module.exports = __webpack_public_path__ + "media/images/flags/4x3/bel-7806d0cb9bc6aa0ca8b4dc1e7ede9743.svg";